import React from 'react';
import { Button } from 'primereact/button';
import { dictionary } from '../../../dictionary';

const isFormValid = (
  ctyLog,
  modTypeLog,
  moduleLog,
  stageLog,
  hourLog,
  taskLog,
  commentLog,
  espLog,
  langLog,
  isEspDialog
) => {
  const hasValidHours = hourLog !== null && hourLog !== undefined;

  if (moduleLog === 'Hour management') {
    return hasValidHours;
  }

  if (moduleLog === 'Drobne_projekty') {
    return ctyLog !== null && modTypeLog !== null && taskLog !== null && hasValidHours && commentLog !== null;
  }

  let isValid = ctyLog !== null && modTypeLog !== null && moduleLog !== null && stageLog !== null && hasValidHours;

  if (isEspDialog) {
    isValid = isValid && espLog !== null && langLog !== null;
  }

  return isValid;
};

const SaveAndEditButtonComponent = ({
  espLog,
  ctyLog,
  langLog,
  versionLog,
  modTypeLog,
  moduleLog,
  stageLog,
  hourLog,
  taskLog,
  commentLog,
  isEspDialog,
  setLockChecked,
  setDevChecked,
  dispatch,
  postEditing,
  setFormSubbmited,
  onLogSave,
  onRowEditComplete,
  resetStateAndOverlay,
  resetCountryButtons,
  dialogProps,
}) => {
  const handleAction = (isUpdate) => {
    setFormSubbmited(true);

    if (
      isFormValid(
        ctyLog,
        modTypeLog,
        moduleLog,
        stageLog,
        hourLog,
        taskLog,
        commentLog,
        espLog,
        langLog,
        versionLog,
        isEspDialog
      )
    ) {
      if (isUpdate) {
        onRowEditComplete();
      } else {
        onLogSave();
      }
      resetStateAndOverlay(setLockChecked, setDevChecked, dialogProps);
      resetCountryButtons(dispatch);
    }
  };

  return (
    <div className="field field-wrapper">
      {!postEditing ? (
        <Button
          label={dictionary.dialog_save_btn}
          icon="pi pi-save"
          className="field-report-btn"
          onClick={() => handleAction(false)}
        />
      ) : (
        <Button
          label={dictionary.dialog_update_btn}
          icon="pi pi-save"
          className="field-report-btn"
          onClick={() => handleAction(true)}
        />
      )}
    </div>
  );
};

export default SaveAndEditButtonComponent;
